import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ButtonComponent } from 'component-library';
import { AuthService } from 'shared';

@Component({
  selector: 'tngh-permission-denied',
  templateUrl: './permission-denied.component.html',
  styleUrls: ['./permission-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonComponent],
})
export class PermissionDeniedComponent {
  private authService = inject(AuthService);

  logout() {
    this.authService.logout();
  }
}
